export default __webpack_public_path__ + "static/media/border-left.2762c522.svg";